import React from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'

import { baseUrl } from 'configs/api'
import { MetaTags } from 'components/MetaTags'
import ErrorBoundary from 'app/DocumentCollectionPage/components/ErrorBoundary'
import { DOCUMENT_PAGE_API_OPTIONS } from 'app/DocumentCollectionPage/configs'
import DocumentDetailPageApp from 'app/DocumentCollectionPage/pages/DocumentDetailPage'

// This value is considered fresh for ten seconds (s-maxage=10).
// If a request is repeated within the next 10 seconds, the previously
// cached value will still be fresh. If the request is repeated before 59 seconds,
// the cached value will be stale but still render (stale-while-revalidate=59).
//
// In the background, a revalidation request will be made to populate the cache
// with a fresh value. If you refresh the page, you will see the new value.
export async function getServerSideProps({ res, params }) {
  try {
    const { id } = params
    const apiBaseUrl = baseUrl

    res.setHeader(
      'Cache-Control',
      'public, s-maxage=600, stale-while-revalidate=1200'
    )

    const response = await fetch(
      `${apiBaseUrl}/guru/teachers/v1alpha1/document-collection/documents/${id}`,
      DOCUMENT_PAGE_API_OPTIONS
    )

    if (response.status !== 200) {
      throw response
    }

    const document = await response.json()
    const { title, description } = document?.data ?? {
      title: 'Dokumen',
      description: '',
    }

    return {
      props: {
        document,
        pageTitle: `${title} - Ruang GTK`,
        pageDescription: description,
        metaTags: {},
      },
    }
  } catch (error) {
    return {
      props: {
        document: {},
        pageTitle: 'Dokumen Rujukan - Ruang GTK',
        pageDescription: '',
        metaTags: {},
        errorCode: error.status,
      },
    }
  }
}

export const DocumentDetailPage = ({ document, errorCode, ...props }) => {
  const router = useRouter()
  return (
    <>
      <Head>
        <title>Dokumen Rujukan - Ruang GTK</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
      </Head>
      <MetaTags {...props} />
      <ErrorBoundary resetKeys={[router.asPath]}>
        <DocumentDetailPageApp
          data={document?.data ?? {}}
          errorCode={errorCode}
        />
      </ErrorBoundary>
    </>
  )
}

// eslint-disable-next-line react/display-name
DocumentDetailPage.Layout = ({ children }) => <>{children}</>

export default DocumentDetailPage
